export default __webpack_public_path__ + "static/aboutBanner-d2e69eb4c18ce75412508633aad017d2.png";